(function () {
  'use strict';

  var cfg = window.PG || {};
  var routes = cfg.routes || { cart: '/cart', cartJs: '/cart.js', add: '/cart/add.js', change: '/cart/change.js' };
  var nf = null;
  try {
    nf = new Intl.NumberFormat(cfg.locale || undefined, { style: 'currency', currency: cfg.currency || 'USD' });
  } catch (e) { nf = null; }

  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    return nf ? nf.format(v) : '$' + v.toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function parse(res) {
    return res.json().then(function (data) {
      if (!res.ok) { throw data; }
      return data;
    });
  }
  function sized(url, w) {
    if (!url) { return ''; }
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var lastCart = null;

  /* ---------- Cart drawer ---------- */
  function drawerEl() { return $('#pg-drawer'); }
  function overlayEl() { return $('#pg-overlay'); }

  function openDrawer() {
    var d = drawerEl(), o = overlayEl();
    if (!d || !o) { return; }
    d.classList.add('open');
    o.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pg-lock');
  }
  function closeDrawer() {
    var d = drawerEl(), o = overlayEl();
    if (!d || !o) { return; }
    d.classList.remove('open');
    o.classList.remove('open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pg-lock');
  }

  function setCount(n) {
    $$('[data-pg-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function lineHtml(item) {
    var src = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
    var img = src ? '<img src="' + esc(sized(src, 160)) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '';
    var variant = item.variant_title ? '<div class="pg-line-var">' + esc(item.variant_title) + '</div>' : '';
    return '<div class="pg-line" data-key="' + esc(item.key) + '">' +
      '<a class="pg-line-img" href="' + esc(item.url) + '">' + img + '</a>' +
      '<div class="pg-line-info">' +
        '<a class="pg-line-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
        variant +
        '<div class="pg-line-row">' +
          '<div class="pg-qty">' +
            '<button type="button" data-pg-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-pg-qty="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<span class="pg-line-price">' + money(item.final_line_price) + '</span>' +
        '</div>' +
        '<button type="button" class="pg-remove" data-pg-remove>Remove</button>' +
      '</div>' +
    '</div>';
  }

  function render(cart) {
    lastCart = cart;
    setCount(cart.item_count);
    var body = $('[data-pg-cart-body]');
    var foot = $('[data-pg-cart-foot]');
    if (!body || !foot) { return cart; }
    if (!cart.items.length) {
      body.innerHTML = '<p class="pg-empty">Your cart is empty.</p>';
      foot.innerHTML = '';
      return cart;
    }
    body.innerHTML = cart.items.map(lineHtml).join('');
    foot.innerHTML =
      '<div class="pg-sub"><span>Subtotal</span><strong>' + money(cart.total_price) + '</strong></div>' +
      '<p class="pg-note">Shipping and taxes calculated at checkout.</p>' +
      '<a class="btn pg-checkout" href="/checkout">Checkout</a>' +
      '<a class="pg-view" href="' + esc(routes.cart) + '">View cart</a>';
    return cart;
  }

  function refresh() {
    return fetch(routes.cartJs, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(parse)
      .then(render);
  }

  function changeLine(key, qty) {
    return fetch(routes.change, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(parse).then(render);
  }

  function findItem(key) {
    if (!lastCart) { return null; }
    for (var i = 0; i < lastCart.items.length; i++) {
      if (lastCart.items[i].key === key) { return lastCart.items[i]; }
    }
    return null;
  }

  /* ---------- Product page ---------- */
  function updateTotal() {
    var total = 0;
    var b = $('[data-pg-bundle][aria-checked="true"]');
    if (b) { total += Number(b.getAttribute('data-price')); }
    $$('[data-pg-addon][aria-checked="true"]').forEach(function (a) {
      total += Number(a.getAttribute('data-price'));
    });
    var el = $('[data-pg-total]');
    if (el) { el.textContent = money(total); }
  }

  function addToCart(btn) {
    var bundle = $('[data-pg-bundle][aria-checked="true"]');
    var err = $('[data-pg-atc-error]');
    if (err) { err.textContent = ''; }
    if (!bundle) { return; }
    var items = [{ id: Number(bundle.getAttribute('data-variant-id')), quantity: 1 }];
    $$('[data-pg-addon][aria-checked="true"]').forEach(function (a) {
      items.push({ id: Number(a.getAttribute('data-variant-id')), quantity: 1 });
    });
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch(routes.add, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(parse)
      .then(function () { return refresh(); })
      .then(function () { openDrawer(); })
      .catch(function (e) {
        if (err) { err.textContent = (e && (e.description || e.message)) || 'Sorry, something went wrong adding to cart.'; }
      })
      .then(function () {
        btn.disabled = false;
        btn.innerHTML = original;
      });
  }

  function selectBundle(el) {
    $$('[data-pg-bundle]').forEach(function (b) {
      b.classList.remove('sel');
      b.setAttribute('aria-checked', 'false');
    });
    el.classList.add('sel');
    el.setAttribute('aria-checked', 'true');
    updateTotal();
  }

  function toggleAddon(el) {
    var on = el.getAttribute('aria-checked') !== 'true';
    el.classList.toggle('on', on);
    el.setAttribute('aria-checked', on ? 'true' : 'false');
    updateTotal();
  }

  function swapThumb(btn) {
    var main = $('#mainImg');
    var full = btn.getAttribute('data-full');
    if (main && full) {
      main.removeAttribute('srcset');
      main.src = full;
    }
    $$('[data-pg-thumb]').forEach(function (t) { t.classList.remove('active'); });
    btn.classList.add('active');
  }

  /* ---------- Before / after slider ---------- */
  function initSliders() {
    $$('[data-pg-ba]').forEach(function (slider) {
      if (slider.getAttribute('data-ready')) { return; }
      slider.setAttribute('data-ready', '1');
      var handle = $('[data-pg-ba-handle]', slider);
      var after = $('[data-pg-ba-after]', slider);
      var dragging = false;
      function move(x) {
        var rect = slider.getBoundingClientRect();
        var pct = Math.max(0, Math.min(1, (x - rect.left) / rect.width)) * 100;
        handle.style.left = pct + '%';
        after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      }
      slider.addEventListener('pointerdown', function (e) {
        dragging = true;
        try { slider.setPointerCapture(e.pointerId); } catch (err) { }
        move(e.clientX);
      });
      slider.addEventListener('pointermove', function (e) { if (dragging) { move(e.clientX); } });
      slider.addEventListener('pointerup', function () { dragging = false; });
      slider.addEventListener('pointercancel', function () { dragging = false; });
    });
  }

  /* ---------- Global click handling ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }

    var openBtn = t.closest('[data-pg-cart-open]');
    if (openBtn && drawerEl() && !/\/cart\/?$/.test(window.location.pathname)) {
      e.preventDefault();
      refresh().then(openDrawer).catch(openDrawer);
      return;
    }
    if (t.closest('[data-pg-close]')) { closeDrawer(); return; }

    var q = t.closest('[data-pg-qty]');
    if (q) {
      var line = q.closest('.pg-line');
      var item = line ? findItem(line.getAttribute('data-key')) : null;
      if (item) { changeLine(item.key, item.quantity + Number(q.getAttribute('data-pg-qty'))); }
      return;
    }
    var rm = t.closest('[data-pg-remove]');
    if (rm) {
      var l2 = rm.closest('.pg-line');
      if (l2) { changeLine(l2.getAttribute('data-key'), 0); }
      return;
    }

    var thumb = t.closest('[data-pg-thumb]');
    if (thumb) { swapThumb(thumb); return; }

    var bundle = t.closest('[data-pg-bundle]');
    if (bundle && !bundle.disabled) { selectBundle(bundle); return; }

    var addon = t.closest('[data-pg-addon]');
    if (addon) { toggleAddon(addon); return; }

    var atc = t.closest('[data-pg-atc]');
    if (atc && !atc.disabled) { addToCart(atc); return; }

    var faq = t.closest('.faq-q');
    if (faq) {
      var itemEl = faq.closest('.faq-item');
      var open = itemEl.classList.toggle('open');
      faq.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.matches && e.target.matches('[data-pg-addon]')) {
      e.preventDefault();
      toggleAddon(e.target);
    }
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) { refresh().catch(function () { }); } });
  document.addEventListener('shopify:section:load', function () { initSliders(); updateTotal(); });

  function init() {
    initSliders();
    updateTotal();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();